"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBalanceData = exports.transformFundBalance = exports.transformTradeBalance = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const AssetModels_1 = require("../Models/AssetModels");
function transformTradeBalance(tradeBalance, debtBalance) {
    const tradeResult = tradeBalance.map((item) => {
        return Object.assign(Object.assign({}, item), { balanceType: AssetModels_1.BALANCE_TYPE_V2.TRADE, frozen: item.frozen, balance: item.balance });
    });
    const debtResult = debtBalance.map((item) => {
        return {
            balanceType: AssetModels_1.BALANCE_TYPE_V2.DEBT,
            currency: item.currency,
            currencyAlias: item.currencyAlias,
            available: item.total,
            frozen: 0,
            balance: -item.total,
            fullName: item.fullName,
            btcPrice: item.btcPrice,
            btcChangePercent: item.btcChangePercent,
            usdPrice: item.usdPrice,
            usdChangePercent: item.usdChangePercent,
        };
    });
    return {
        trade: tradeResult,
        debt: debtResult,
    };
}
exports.transformTradeBalance = transformTradeBalance;
function toExchangeBalanceV2(market, balanceType, currency, balance, prices) {
    var _a, _b, _c, _d;
    const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getMarketSymbol(market)
        .find((item) => item.base === currency);
    return {
        currency: currency,
        currencyAlias: symbolInfo ? symbolInfo.baseDisplay : currency,
        fullName: prices[currency] ? prices[currency].full_name : currency,
        balanceType,
        available: 0,
        frozen: new trade_utils_lib_1.SafeDecimal(balance === null || balance === void 0 ? void 0 : balance.total).toNumber(),
        balance: new trade_utils_lib_1.SafeDecimal(balance === null || balance === void 0 ? void 0 : balance.total).toNumber(),
        usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[currency]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
        usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[currency]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
        btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[currency]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
        btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[currency]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
    };
}
function toExchangeBalanceList(market, balanceType, balances, prices) {
    if (!balances) {
        return [];
    }
    return Object.keys(balances).map((currency) => {
        return toExchangeBalanceV2(market, balanceType, currency, balances[currency], prices);
    });
}
function mergeExchangeBalance(balance1, balance2) {
    var _a, _b;
    const balance = Object.assign({}, balance1);
    balance.frozen = new trade_utils_lib_1.SafeDecimal(balance1.frozen).add(balance2.frozen).toNumber();
    balance.balance = new trade_utils_lib_1.SafeDecimal(balance1.balance).add(balance2.balance).toNumber();
    balance.available = new trade_utils_lib_1.SafeDecimal(balance1.available).add(balance2.available).toNumber();
    balance.unrealizedProfit = new trade_utils_lib_1.SafeDecimal((_a = balance1.unrealizedProfit) !== null && _a !== void 0 ? _a : 0).add((_b = balance2.unrealizedProfit) !== null && _b !== void 0 ? _b : 0).toNumber();
    return balance;
}
function mergeExchangeBalanceList(...balances) {
    const balanceMap = new Map();
    balances.forEach((balance) => {
        const balance1 = balanceMap.get(balance.currency);
        if (balance1) {
            balanceMap.set(balance.currency, mergeExchangeBalance(balance1, balance));
        }
        else {
            balanceMap.set(balance.currency, balance);
        }
    });
    return Array.from(balanceMap.values());
}
// 将modules下的所有资产合并返回
function toModuleBalanceList(market, balanceType, modules, prices) {
    let moduleAssets = [];
    if (modules) {
        Object.keys(modules).forEach((module) => {
            const balanceList = toExchangeBalanceList(market, balanceType, modules[module].currencies, prices);
            if (balanceList.length > 0) {
                moduleAssets = mergeExchangeBalanceList(...moduleAssets, ...balanceList);
            }
        });
    }
    return moduleAssets;
}
function transformFundBalance(fundBalanceList) {
    const balanceList = [];
    fundBalanceList.forEach((value) => {
        if (typeof value.available === "string" || typeof value.available === "number") {
            value.available = new trade_utils_lib_1.SafeDecimal(value.available);
            value.frozen = new trade_utils_lib_1.SafeDecimal(value.frozen);
        }
        if (value.fundCode === value.fundCurrency) {
            const find = balanceList.find((item) => item.currency === value.fundCurrency);
            if (find) {
                find.balance += value.available.add(value.frozen).toNumber();
                find.frozen += value.frozen.toNumber();
                find.available += value.available.toNumber();
            }
            else {
                balanceList.push({
                    balanceType: TradeAPILib_1.BALANCE_TYPE.FUND,
                    currency: value.fundCurrency,
                    currencyAlias: value.fundCurrency,
                    available: value.available.toNumber(),
                    frozen: value.frozen.toNumber(),
                    balance: value.available.add(value.frozen).toNumber(),
                    btcPrice: value.btcPrice,
                    btcChangePercent: value.btcChangePercent,
                    usdPrice: value.usdPrice,
                    usdChangePercent: value.usdChangePercent,
                });
            }
        }
        else {
            // 基金
            const tmp = value.available.add(value.frozen).mul(value.price).toNumber();
            const find = balanceList.find((item) => item.currency === value.fundCurrency);
            if (find) {
                find.balance += tmp;
                find.frozen += tmp;
            }
            else {
                balanceList.push({
                    currency: value.fundCurrency,
                    currencyAlias: value.fundCurrency,
                    balanceType: TradeAPILib_1.BALANCE_TYPE.FUND,
                    available: 0,
                    frozen: tmp,
                    balance: tmp,
                    btcPrice: value.btcPrice,
                    btcChangePercent: value.btcChangePercent,
                    usdPrice: value.usdPrice,
                    usdChangePercent: value.usdChangePercent,
                });
            }
        }
    });
    return balanceList;
}
exports.transformFundBalance = transformFundBalance;
function formatBalanceData(result, apiKey) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    const prices = result.data.prices || {};
    let tradeAssets = [];
    let debtAssets = [];
    let swapAssets = [];
    let cmSwapAssets = [];
    let arbitrageStrategyAssets = [];
    let manualAssets = [];
    let traderAccount = [];
    // 现货:手动+策略整合
    if (result.data.trade) {
        const { manual, bot_strategy } = result.data.trade;
        let tradeBalance = {};
        if (manual && bot_strategy) {
            // 整合 manual 和 strategy
            const manualCurrencies = (_a = manual.currencies) !== null && _a !== void 0 ? _a : {};
            const strategyCurrencies = (_b = bot_strategy.currencies) !== null && _b !== void 0 ? _b : {};
            const manualAllCoins = Object.keys(manualCurrencies);
            const strategyAllCoins = Object.keys(strategyCurrencies);
            const spotAllCoins = Array.from(new Set([...manualAllCoins, ...strategyAllCoins]));
            spotAllCoins.map((coin) => {
                const manualInfo = manualCurrencies[coin];
                const strategyInfo = strategyCurrencies[coin];
                tradeBalance[coin] = {};
                tradeBalance[coin].total = new trade_utils_lib_1.SafeDecimal(manualInfo === null || manualInfo === void 0 ? void 0 : manualInfo.total).add(new trade_utils_lib_1.SafeDecimal(strategyInfo === null || strategyInfo === void 0 ? void 0 : strategyInfo.total)).toNumber();
                tradeBalance[coin].free = new trade_utils_lib_1.SafeDecimal(manualInfo === null || manualInfo === void 0 ? void 0 : manualInfo.free).toNumber();
                tradeBalance[coin].used = new trade_utils_lib_1.SafeDecimal(manualInfo === null || manualInfo === void 0 ? void 0 : manualInfo.used).add(new trade_utils_lib_1.SafeDecimal(strategyInfo === null || strategyInfo === void 0 ? void 0 : strategyInfo.total)).toNumber();
            });
        }
        if (tradeBalance) {
            tradeAssets = Object.keys(tradeBalance)
                .map((coin) => {
                var _a, _b, _c, _d;
                let coinInfo = tradeBalance[coin];
                const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .getMarketSymbol(apiKey.market)
                    .find((item) => item.base === coin);
                return {
                    currency: coin,
                    currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                    fullName: prices[coin] ? prices[coin].full_name : coin,
                    balanceType: AssetModels_1.BALANCE_TYPE_V2.TRADE,
                    available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                    frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                    balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                    usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                    usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                    btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                    btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                };
            })
                .filter((obj) => {
                return obj.currency !== "Cointype_NA";
            });
        }
    }
    // 借贷
    if ((_d = (_c = result.data.trade) === null || _c === void 0 ? void 0 : _c.bot_strategy_loan) === null || _d === void 0 ? void 0 : _d.debts) {
        const debtBalance = result.data.trade.bot_strategy_loan.debts;
        debtAssets = debtBalance.map((item) => {
            var _a, _b, _c, _d;
            const coin = item.coin;
            let coinInfo = item;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            return {
                currency: coin,
                balanceType: AssetModels_1.BALANCE_TYPE_V2.DEBT,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                total: new trade_utils_lib_1.SafeDecimal(coinInfo.principal || 0).add(coinInfo.interest).toNumber(),
                principal: new trade_utils_lib_1.SafeDecimal(coinInfo.principal || 0).toNumber(),
                interest: new trade_utils_lib_1.SafeDecimal(coinInfo.interest || 0).toNumber(),
                fullName: prices[coin] ? prices[coin].full_name : coin,
                usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
            };
        });
    }
    // 合约
    if ((_g = (_f = (_e = result.data) === null || _e === void 0 ? void 0 : _e.finance) === null || _f === void 0 ? void 0 : _f.swap) === null || _g === void 0 ? void 0 : _g.currencies) {
        const swapBalance = result.data.finance.swap.currencies;
        swapAssets = Object.keys(swapBalance).map((coin) => {
            var _a, _b, _c, _d, _e;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            let coinInfo = swapBalance[coin];
            const available = new trade_utils_lib_1.SafeDecimal(coin === "USDT" ? (_a = result.data.finance.swap) === null || _a === void 0 ? void 0 : _a.available_balance : coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free);
            return {
                currency: coin,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                fullName: prices[coin] ? prices[coin].full_name : coin,
                balanceType: AssetModels_1.BALANCE_TYPE_V2.SWAP,
                available: available.toNumber(),
                frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(available).toNumber(),
                balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                usdPrice: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_e = prices[coin]) === null || _e === void 0 ? void 0 : _e.change_24h_in_btc).toNumber(),
                unrealizedProfit: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.unrealized_profit).toNumber(),
            };
        });
    }
    // manual 手动
    if ((_j = (_h = result.data.trade) === null || _h === void 0 ? void 0 : _h.manual) === null || _j === void 0 ? void 0 : _j.currencies) {
        const manualBalance = result.data.trade.manual.currencies;
        manualAssets = Object.keys(manualBalance).map((coin) => {
            var _a, _b, _c, _d;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            let coinInfo = manualBalance[coin];
            return {
                currency: coin,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                fullName: prices[coin] ? prices[coin].full_name : coin,
                balanceType: AssetModels_1.BALANCE_TYPE_V2.TRADE,
                available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
            };
        });
    }
    // coin margin  合约
    if ((_l = (_k = result.data.finance) === null || _k === void 0 ? void 0 : _k.cm_swap) === null || _l === void 0 ? void 0 : _l.currencies) {
        const cmBalance = result.data.finance.cm_swap.currencies;
        cmSwapAssets = Object.keys(cmBalance).map((coin) => {
            var _a, _b, _c, _d;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            let coinInfo = cmBalance[coin];
            return {
                currency: coin,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                fullName: prices[coin] ? prices[coin].full_name : coin,
                balanceType: AssetModels_1.BALANCE_TYPE_V2.CM_SWAP,
                available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
                unrealizedProfit: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.unrealized_profit).toNumber(),
            };
        });
    }
    // 套利现货部分
    if ((_o = (_m = result.data.finance) === null || _m === void 0 ? void 0 : _m.arbitrage_strategy) === null || _o === void 0 ? void 0 : _o.currencies) {
        const arbitrageStrategyBalance = (_q = (_p = result.data.finance) === null || _p === void 0 ? void 0 : _p.arbitrage_strategy) === null || _q === void 0 ? void 0 : _q.currencies;
        arbitrageStrategyAssets = Object.keys(arbitrageStrategyBalance).map((coin) => {
            var _a, _b, _c, _d;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            let coinInfo = arbitrageStrategyBalance[coin];
            return {
                currency: coin,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                fullName: prices[coin] ? prices[coin].full_name : coin,
                balanceType: AssetModels_1.BALANCE_TYPE_V2.ARBITRAGE_STRATEGY,
                available: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                frozen: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).sub(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.free).toNumber(),
                balance: new trade_utils_lib_1.SafeDecimal(coinInfo === null || coinInfo === void 0 ? void 0 : coinInfo.total).toNumber(),
                usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
            };
        });
    }
    // 交易员账户
    if ((_r = result.data.trader_account) === null || _r === void 0 ? void 0 : _r.manual) {
        const manualBalance = result.data.trader_account.manual;
        traderAccount = manualBalance.map((coinInfo) => {
            var _a, _b, _c, _d;
            const coin = coinInfo.coin;
            const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getMarketSymbol(apiKey.market)
                .find((item) => item.base === coin);
            const item = {
                balanceType: AssetModels_1.BALANCE_TYPE_V2.TRADER_ACCOUNT,
                currency: coin,
                currencyAlias: symbolInfo ? symbolInfo.baseDisplay : coin,
                fullName: prices[coin] ? prices[coin].full_name : coin,
                assets: coinInfo.assets,
                free: coinInfo.free,
                frozen: coinInfo.frozen,
                available: coinInfo.available,
                unrealizedProfit: coinInfo.unrealized_pnl,
                totalInitialMargin: coinInfo.total_initial_margin,
                transferable: coinInfo.transferable,
                debts: coinInfo.debts,
                payable: coinInfo.payable,
                loan: coinInfo.loan,
                interest: coinInfo.interest,
                usdPrice: new trade_utils_lib_1.SafeDecimal((_a = prices[coin]) === null || _a === void 0 ? void 0 : _a.price_in_usd).toNumber(),
                usdChangePercent: new trade_utils_lib_1.SafeDecimal((_b = prices[coin]) === null || _b === void 0 ? void 0 : _b.change_24h_in_usd).toNumber(),
                btcPrice: new trade_utils_lib_1.SafeDecimal((_c = prices[coin]) === null || _c === void 0 ? void 0 : _c.price_in_btc).toNumber(),
                btcChangePercent: new trade_utils_lib_1.SafeDecimal((_d = prices[coin]) === null || _d === void 0 ? void 0 : _d.change_24h_in_btc).toNumber(),
            };
            return item;
        });
    }
    // 活期理财
    const depositAssets = toExchangeBalanceList(apiKey.market, AssetModels_1.BALANCE_TYPE_V2.DEPOSIT, (_t = (_s = result.data.finance) === null || _s === void 0 ? void 0 : _s.deposit) === null || _t === void 0 ? void 0 : _t.currencies, prices);
    // 结构理财
    const dualAssets = toExchangeBalanceList(apiKey.market, AssetModels_1.BALANCE_TYPE_V2.DUAL, (_v = (_u = result.data.finance) === null || _u === void 0 ? void 0 : _u.dual) === null || _v === void 0 ? void 0 : _v.currencies, prices);
    // 结构理财复投
    const dualAutoAssets = toExchangeBalanceList(apiKey.market, AssetModels_1.BALANCE_TYPE_V2.DUAL_AUTO, (_x = (_w = result.data.finance) === null || _w === void 0 ? void 0 : _w.dual_auto) === null || _x === void 0 ? void 0 : _x.currencies, prices);
    // 交易modules
    const moduleTradeAssets = toModuleBalanceList(apiKey.market, AssetModels_1.BALANCE_TYPE_V2.TRADE, (_y = result.data.trade) === null || _y === void 0 ? void 0 : _y.modules, prices);
    if (moduleTradeAssets.length > 0) {
        tradeAssets = mergeExchangeBalanceList(...tradeAssets, ...moduleTradeAssets);
        manualAssets = mergeExchangeBalanceList(...manualAssets, ...moduleTradeAssets);
    }
    // 理财modules
    const moduleFinanceAssets = toModuleBalanceList(apiKey.market, AssetModels_1.BALANCE_TYPE_V2.MODULE_FINANCE, (_z = result.data.finance) === null || _z === void 0 ? void 0 : _z.modules, prices);
    return {
        trade: tradeAssets,
        debt: debtAssets,
        swap: swapAssets,
        assetExcludeBot: manualAssets,
        cmSwap: cmSwapAssets,
        arbitrageStrategy: arbitrageStrategyAssets,
        deposit: depositAssets,
        dual: dualAssets,
        dualAuto: dualAutoAssets,
        moduleFinance: moduleFinanceAssets,
        traderAccount: traderAccount,
        total: {
            manualTotalInBTC: new trade_utils_lib_1.SafeDecimal((_0 = result.data.total) === null || _0 === void 0 ? void 0 : _0.trader_account_in_btc).toNumber(),
            manualTotalInUSD: new trade_utils_lib_1.SafeDecimal((_1 = result.data.total) === null || _1 === void 0 ? void 0 : _1.trader_account_in_usd).toNumber(),
            financeTotalInBTC: new trade_utils_lib_1.SafeDecimal((_2 = result.data.total) === null || _2 === void 0 ? void 0 : _2.finance_total_in_btc).toNumber(),
            financeTotalInUSD: new trade_utils_lib_1.SafeDecimal((_3 = result.data.total) === null || _3 === void 0 ? void 0 : _3.finance_total_in_usd).toNumber(),
            totalInBTC: new trade_utils_lib_1.SafeDecimal((_4 = result.data.total) === null || _4 === void 0 ? void 0 : _4.total_in_btc).toNumber(),
            totalInUSD: new trade_utils_lib_1.SafeDecimal((_5 = result.data.total) === null || _5 === void 0 ? void 0 : _5.total_in_usd).toNumber(),
            tradeTotalInBTC: new trade_utils_lib_1.SafeDecimal((_6 = result.data.total) === null || _6 === void 0 ? void 0 : _6.trade_total_in_btc).toNumber(),
            tradeTotalInUSD: new trade_utils_lib_1.SafeDecimal((_7 = result.data.total) === null || _7 === void 0 ? void 0 : _7.trade_total_in_usd).toNumber(),
        },
    };
}
exports.formatBalanceData = formatBalanceData;
